<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <p><strong>Agent being used for this enrollment: {{enrollmentViewModel.AGENTNAME}}</strong></p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <ElectionPeriod [reasonCode]="reasonCode.toString()"
                            [periodSelected]="periodSelected"
                            (periodSelectdChanged)="periodSelectdChanged($event)"
                            (reasonCodeChanged)="reasonCodeChanged($event)"
                            (hasDateField)="hasDateField($event)"
                            (sepDateChange)="sepdatechange($event)">
            </ElectionPeriod>
        </div>
    </div>

    <div class="row" style="display:flex;">
        <div class="col-24">
            <drugplan [enrollmentDrugViewModel]="enrollmentViewModel"></drugplan>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <beneficiary-info [enrollment]="enrollmentViewModel.beneficiaryInfo"
                              (onValueChange)="change($event)"></beneficiary-info>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <DualAddress [topAddress]="residentialAddress"
                         [bottomAddress]="mailingAddress"
                         [topAddressName]="'Residential Address'"
                         [bottomAddressName]="'Mailing Address'"
                         [LTCFacilityName]="enrollmentViewModel.LTCFACILITY"
                         [LTCFacilityPhone]="enrollmentViewModel.LTCPHONE"
                         [states]="states"
                         [disabled]="disabled"
                         [allowPOBoxes]="true"
                         [isExternalAgentEnrl] ="isExternalAgentEnrl"
                         [poBox]="true"
                         [checked]="isPOBox"
                         (onValueChange)="poBoxChecked($event)"
                         (onTopAddressChange)="residentialAddressChanged($event)"
                         (onBottomAddressChange)="mailingAddressChanged($event)"
                         (onLTCFacilityNameChange)="enrollmentViewModel.LTCFACILITY=$event"
                         (onLTCFacilltyPhoneChange)="enrollmentViewModel.LTCPHONE=$event">
            </DualAddress>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <!--<eob (onEobOptionChange)="this.eobOptionChanged($event)"
            [EOBEmaildisabled]="false"
            [eobOption]="enrollmentViewModel.EOB"
            [email]="enrollmentViewModel.APPEMAIL"
            (onEmailChange)="this.emailChanged($event)"
            [PaperlessOption]="PaperlessOption"></eob>-->
            <div *ngIf="PaperlessOption">
                <div class="row">
                    <div class="col-16">
                        <p><strong>Paperless Settings</strong></p>
                    </div>
                    <div class="col-16">
                        <p>
                            Would you like to receive paperless Explanation of Benefit (EOB) statements?
                        </p>
                        <div class="row">
                            <br />
                        </div>
                        <p>
                            We'll send you a monthly email letting you know how to access and view your secure EOB statement. You will need to provide us with your email address. You can opt out at any time.
                        </p>

                    </div>

                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <!--<p><strong>Do you want paperless documents?</strong></p> -->
                        </div>
                        <div class="bottom-20">
                            <ValidatedCheckbox [id]="'eobOptions'"
                                               [label]="eobOptionLabel"
                                               [checked]="isEOB"
                                               (onValueChange)="eobOptionChecked($event)">
                            </ValidatedCheckbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <p>
                            Visit the online preference center at <a class="link" href="https://www.aetnamedicare.com" target="_blank">aetnamedicare.com</a> once you complete your registration by clicking Login and following the steps for register. See exactly what's available for you to receive digitally and manage your document delivery preferences between digital and mailed. You may go back to paper at any time. Please note that some documents may take up to two months to switch to digital delivery. Thank you for going paperless!
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]=""
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                We will use your email address to keep you up to date on your SilverScript plan.
                                You can opt out any time.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!PaperlessOption">

                <div class="row">
                    <div class="col-16">
                        <p><strong>Would you like to receive paperless Explanation of Benefit (EOB) statements?</strong></p>
                        <p>We'll send you a monthly email alert to view your statement. You can print it only if you need to - keep the clutter down and your information secure.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <ValidatedRadioButtonGroup [options]="rdBtnEOB"
                                                       [selectedValue]="enrollmentViewModel.EOB"
                                                       [radioGroupName]="'rdBtnEOB'"
                                                       (onValueChange)="eobOptionChanged($event)">
                            </ValidatedRadioButtonGroup>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="bottom-20">
                            <label>{{emailLabel}}</label>
                            <ValidatedTextField class="" [maxlength]="40"
                                                [label]=""
                                                id="EmailAddress"
                                                [text]="enrollmentViewModel.APPEMAIL"
                                                (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                We will use your email address to keep you up to date on your SilverScript plan.
                                You can opt out any time.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                The Explanation of Benefits (EOB) is a record of your prescription claims that have been processed for the month. The EOB statement shows each prescription’s cost,
                                the amount your plan has paid toward its cost, and the amount for which you’re responsible. You can change your preference on caremark.com at any time.
                            </p>
                            <p>
                                If you choose to receive paperless Explanation of Benefit statements, you will need to create an account on Caremark.com.
                                In addition to viewing your EOB statements online, Caremark.com will give you the ability to track your prescription costs and order mail service prescriptions.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">

            <payment-method id="payment-method"
                            (onPaymentOptionChange)="this.paymentOptionChanged($event)"
                            (onPaymentAccountChange)="this.paymentAccountChanged($event)"
                            [paymentOption]="this.paymentOption"
                            [paymentAccount]="this.paymentAccount">
            </payment-method>
        </div>
    </div>

    <div class="row" style="clear:left;display:flex;">
        <div class="col-24">
            <prescripitionDrug [enrollment]="enrollmentViewModel"
                               [isExternalAgentEnrl] ="isExternalAgentEnrl"
                               #prescripitionDrug>

            </prescripitionDrug>
        </div>
    </div>

    <div class="row" style="clear:left; display:flex;">
        <div class="col-24">
            <accessibility [accessibilityValue]="accessibilityValue" [enrollment]="enrollmentViewModel"></accessibility> 
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <notes [enrollment]="enrollmentViewModel"></notes>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Continue</button>
            <button class="button primary" (click)="incompleteClick()">Continue As Incomplete</button>
            <button class="button cancel" (click)="goBack()">Go Back</button>

        </div>
    </div>
</div>
